export default __webpack_public_path__ + "static/media/17w.c087b582.svg";